export const initialState = {
  filters: {},
  exercises: [],
  exercise: {},
  exerciseBySlug: {},
  editTranslation: {},
  loading: false,
  totalCount: 0
};
